import { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { AppsOutlined } from '@mui/icons-material';
import { useApplicationContext } from '../../context/application';
import { useAuthContext } from '../../context/auth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { ConfirmDialog } from '../dialogKit';

const Delete = ({ id, name }) => {
  const axiosPrivate = useAxiosPrivate();
  const { dispatch } = useApplicationContext();
  const { auth } = useAuthContext();
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleDelete = async () => {
    if (!auth) {
      setError('You must be logged in');
      return;
    }

    setBusy(true);
    setError(null);
    try {
      const response = await axiosPrivate.delete(`/api/applications/${id}`);
      dispatch({ type: 'DELETE_APPLICATION', payload: response.data });
      setShow(false);
    } catch (error) {
      setError(error.response?.data?.error || 'Delete failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Tooltip title="Delete application">
        <IconButton
          color="secondary"
          size="small"
          onClick={() => { setError(null); setShow(true); }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <ConfirmDialog
        open={show}
        onClose={() => setShow(false)}
        onConfirm={handleDelete}
        busy={busy}
        error={error}
        title="Delete application?"
        message="The application is removed from the list for every user."
        item={name}
        itemIcon={AppsOutlined}
        confirmLabel="Delete application"
      />
    </>
  );
};

export default Delete;
